/**
 * Splits 'raw' content into multiple raw objects at atomic blocks.
 * Split occurs at atomic blocks (typically media blocks like form, price etc.).
 * Each resulting raw object contains only 1 atomic element.
 *
 * @param {Object} raw - The Draft.js raw content object to split
 * @returns {Array} returns[] Array of content raw objects
 */
export const splitRawByAtomic = (raw) => {
  const { blocks, entityMap } = raw;
  const result = [];

  let currentBlocks = [];
  let usedEntityKeys = new Set();

  const pushRaw = () => {
    if (currentBlocks.length === 0) return;
    const newEntityMap = {};
    usedEntityKeys.forEach((key) => {
      if (entityMap[key]) {
        newEntityMap[key] = entityMap[key];
      }
    });

    result.push({
      blocks: currentBlocks,
      entityMap: newEntityMap,
    });

    currentBlocks = [];
    usedEntityKeys = new Set();
  };

  for (const block of blocks) {
    currentBlocks.push(block);

    for (const range of block.entityRanges) {
      usedEntityKeys.add(range.key);
    }

    // If this is atomic -> push current chunk as separate raw
    if (block.type === 'atomic') {
      pushRaw();
    }
  }

  // Push any remaining blocks after last atomic
  pushRaw();

  return result;
};
